import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { Input } from '@/components/ui/Input';
import { XStack } from '@/components/ui/layout/layout';

import { traceViewerStore } from './trace-viewer.store';

export const SearchInput = observer(() => {
  const store = traceViewerStore;

  return (
    <XStack className="items-center gap-2 border-b border-border bg-surface ">
      <div className="flex-1 relative">
        <Input
          placeholder="Search spans by name or tags..."
          value={store.searchQuery}
          onChange={(e) => store.setSearchQuery(e.target.value)}
          className="h-8 text-sm pr-8 w-full rounded-md overflow-hidden"
        />
        {store.searchQuery && (
          <button
            onClick={() => store.clearSearch()}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-surface-hover rounded transition-colors"
            title="Clear search"
          >
            <Icons.cancel className="h-3 w-3 text-foreground-subtle" />
          </button>
        )}
      </div>
    </XStack>
  );
});
